// extracted by mini-css-extract-plugin
export var headerCell = "_z-1";
export var loadingSpinnerContainer = "_z-4";
export var rowWrapper = "_z-3";
export var standaloneTable = "_z-5";
export var table = "_z-0";
export var white = "_z-2";